import { useContext } from "react"
import AppInfoContext from "src/provider/state-manager/appInfoProvider"

function SvgComponent(props: any) {
    const {info: {theme}} = useContext(AppInfoContext)

    return (
        <svg
            width={44}
            height={44}
            viewBox="0 0 44 44"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
        <path
            d="M14.995 1.81A17.692 17.692 0 001.81 14.996a30.675 30.675 0 000 14.01A17.692 17.692 0 0014.995 42.19a30.675 30.675 0 0014.01 0A17.692 17.692 0 0042.19 29.005a30.675 30.675 0 000-14.01A17.692 17.692 0 0029.005 1.81a30.675 30.675 0 00-14.01 0z"
            fill={props.isHover ? theme['#0D968F'] : theme["#B4E3E1"]}
            stroke="#fff"
            strokeWidth={2}
        />
        <circle cx={22} cy={22.833} r={2.5} stroke={props.isHover ? '#ffffff' : theme["#0D968F"]} strokeWidth={1.5} />
        <path
            d="M20.148 29.5h3.704c2.601 0 3.901 0 4.836-.613a3.672 3.672 0 001.021-1.003c.625-.917.625-2.194.625-4.748 0-2.553 0-3.83-.625-4.747a3.671 3.671 0 00-1.021-1.003c-.6-.394-1.352-.535-2.503-.585a1.172 1.172 0 01-1.13-.937 1.72 1.72 0 00-1.693-1.364h-2.723a1.72 1.72 0 00-1.694 1.364c-.108.528-.58.937-1.13.937-1.15.05-1.902.19-2.502.585a3.67 3.67 0 00-1.022 1.003c-.624.917-.624 2.194-.624 4.747 0 2.554 0 3.83.624 4.748.27.397.618.738 1.022 1.003.934.613 2.235.613 4.835.613z"
            stroke={props.isHover ? '#ffffff' : theme["#0D968F"]}
            strokeWidth={1.5}
        />
        <path
            d="M27.833 20.333H27"
            stroke={props.isHover ? '#ffffff' : theme["#0D968F"]}
            strokeWidth={1.5}
            strokeLinecap="round"
        />
        </svg>
    )
}
  
  export default SvgComponent